import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=126dda7a&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=126dda7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dda7a",
  null
  
)

export default component.exports